
import React from 'react';
import { CopyrightBundleLayout } from '../../components/CopyrightBundleLayout';
import { Verified } from '@mui/icons-material';
import { useLanguage } from '../../contexts/LanguageContext';

export const CopyrightLetterScreen: React.FC = () => {
  const { t } = useLanguage();
  return (
    <CopyrightBundleLayout>
        <div className="w-full max-w-[700px] mb-8 flex justify-between items-center">
            <h4 className="text-sm font-bold text-slate-900 uppercase tracking-widest">{t('copyright.letter.title')}</h4>
            <span className="px-2 py-1 bg-emerald-50 text-emerald-600 text-[10px] font-bold rounded border border-emerald-100">{t('copyright.letter.seal')}</span>
        </div>
        <div className="w-full max-w-[700px] bg-white border border-slate-200 shadow-xl min-h-[900px] p-16 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-slate-50 rotate-45 translate-x-16 -translate-y-16"></div>
            <div className="flex justify-between items-start mb-20 relative">
                <div className="space-y-1">
                    <div className="flex items-center gap-2 text-primary mb-4">
                        <Verified className="text-4xl" />
                        <span className="text-xl font-black tracking-tighter">{t('appName')}</span>
                    </div>
                    <h2 className="text-3xl font-light text-slate-900 tracking-tight">{t('copyright.letter.certTitle')}</h2>
                    <p className="text-[11px] font-bold text-slate-400 uppercase tracking-widest">{t('copyright.letter.certSub')}</p>
                </div>
                <div className="text-right">
                    <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{t('copyright.letter.docId')}</p>
                    <p className="text-sm font-mono text-slate-900 font-bold">OCS-CERT-8832-LW</p>
                    <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-4">{t('copyright.letter.date')}</p>
                    <p className="text-sm text-slate-900">October 24, 2023</p>
                </div>
            </div>

            <div className="space-y-8 relative">
                <div className="border-l-2 border-primary pl-6 py-2">
                    <h3 className="text-sm font-bold text-slate-900 mb-2">{t('copyright.letter.subject')}</h3>
                    <div className="grid grid-cols-2 gap-y-4">
                        <div>
                            <p className="text-[9px] font-bold text-slate-400 uppercase">{t('copyright.letter.prodName')}</p>
                            <p className="text-xs font-semibold text-slate-700">Luxury Chronograph Series X</p>
                        </div>
                        <div>
                            <p className="text-[9px] font-bold text-slate-400 uppercase">{t('copyright.letter.sku')}</p>
                            <p className="text-xs font-semibold text-slate-700">LW-2023-OZON-001</p>
                        </div>
                        <div>
                            <p className="text-[9px] font-bold text-slate-400 uppercase">{t('copyright.letter.jurisdiction')}</p>
                            <p className="text-xs font-semibold text-slate-700">Global E-commerce (WIPO)</p>
                        </div>
                        <div>
                            <p className="text-[9px] font-bold text-slate-400 uppercase">{t('copyright.letter.grade')}</p>
                            <p className="text-xs font-semibold text-emerald-600">{t('copyright.letter.gradeValue')}</p>
                        </div>
                    </div>
                </div>

                <div className="space-y-4 text-xs leading-relaxed text-slate-600 font-serif">
                    <p>{t('copyright.letter.body1')}</p>
                    <p>{t('copyright.letter.body2')}</p>
                </div>

                <div className="mt-24 pt-12 border-t border-slate-100 flex justify-between items-end">
                    <div className="space-y-4">
                        <div className="w-40 h-[1px] bg-slate-200"></div>
                        <p className="text-[10px] font-bold text-slate-900">{t('copyright.letter.officer')}</p>
                        <p className="text-[9px] text-slate-400 font-mono italic">{t('copyright.letter.signature')} 0x4B...A922</p>
                    </div>
                    <div className="relative w-32 h-32 flex items-center justify-center opacity-80">
                        <div className="absolute inset-0 border-4 border-primary/20 rounded-full flex items-center justify-center rotate-[-15deg]">
                            <div className="w-[100px] h-[100px] border-2 border-primary/30 rounded-full border-dashed flex flex-col items-center justify-center">
                                <span className="text-[8px] font-black text-primary/40 uppercase mb-1">Authenticated</span>
                                <Verified className="text-primary/30 text-3xl" />
                                <span className="text-[8px] font-black text-primary/40 uppercase mt-1">OneClickSell</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="absolute bottom-8 left-16 right-16 flex justify-between text-[8px] font-bold text-slate-300 uppercase tracking-[0.2em]">
                <span>{t('copyright.letter.footer1')}</span>
                <span>{t('copyright.letter.footer2')}</span>
            </div>
        </div>
    </CopyrightBundleLayout>
  );
};
